import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Link } from "react-router-dom";
import Layout from "../component/layout";
import AuditLogsContent from "../audit_logs/AuditLogsContent";
import Services from "./Services";

const SystemIndex = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Layout>
      {/* Header */}
      <div className="page-header bg-light border-bottom">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <ul className="breadcrumb mb-2">
                <li className="breadcrumb-item">
                  <Link to="/core/dashboard" className="text-muted">
                    <i className="ti ti-home me-1"></i>Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active text-dark">System</li>
              </ul>
              <div className="page-header-title">
                <h2 className="mb-1 text-dark fw-semibold">
                  <i className="ti ti-settings me-2 text-primary"></i>System
                  Management
                </h2>
                <p className="mb-0 text-muted">
                  Monitor system activities, audit logs, and service health
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <TabView
                activeIndex={activeTab}
                onTabChange={(e) => setActiveTab(e.index)}
              >
                <TabPanel header="Audit Logs" leftIcon="ti ti-activity me-2">
                  <div className="mt-3">
                    <AuditLogsContent />
                  </div>
                </TabPanel>

                <TabPanel header="Services" leftIcon="ti ti-server me-2">
                  <div className="mt-3">
                    <Services />
                  </div>
                </TabPanel>
              </TabView>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SystemIndex;
